<template>
  <component :is="component"></component>
</template>

<script>
import FinanceIndicatorHK from './FinanceIndicatorHk.vue'
import FinanceIndicatorUS from './FinanceIndicatorUs.vue'
import FinanceIndicatorHs from './FinanceIndicatorHs.vue'
const components = {
  hk: FinanceIndicatorHK,
  hs: FinanceIndicatorHs,
  us: FinanceIndicatorUS
}
export default {
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    component() {
      return components[this.market]
    }
  }
}
</script>
